"use client"

import { useEvmTransactFunction } from "../arch/evm/useEvmTransactFunction"
import type { PolychainError } from "../lib/errors"
import type { TransactFunction } from "../types"

type UseTransact = {
  transact: TransactFunction
  data: string | undefined
  error: PolychainError | undefined
  isPending: boolean
  isSuccess: boolean
  isError: boolean
  isIdle: boolean
  isPaused: boolean
}

/**
 * Transaction helper function
 * @returns object:
 *  - transact: function that sends a transaction
 */
export const useTransact = (): UseTransact => {
  const evmTransact = useEvmTransactFunction()
  return evmTransact
}
